/**
 * dialer.leadstoresniper.com: LeadStoreSniper's unlimited dialer, served by
 * this app on its own address. On a dialer host the app shows only what a
 * dialer agent needs and lands on the dialer console after sign-in. The hosts
 * come from NEXT_PUBLIC_DIALER_HOSTS (comma separated) so staging can use its own.
 */
const DEFAULT_DIALER_HOSTS = ["dialer.leadstoresniper.com"];

export const DIALER_CONSOLE_PATH = "/dialer/unlimited";

/** Sidebar entries a dialer host keeps, after the console itself. */
export const DIALER_HOST_NAV = new Set(["/leads", "/appointments", "/lead-sniper", "/settings"]);

export function dialerHosts(): string[] {
  const raw = process.env.NEXT_PUBLIC_DIALER_HOSTS;
  return (raw ? raw.split(",") : DEFAULT_DIALER_HOSTS).map((h) => h.trim().toLowerCase()).filter(Boolean);
}

export function isDialerHost(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== "undefined" ? window.location.hostname : "")).toLowerCase();
  return !!host && dialerHosts().includes(host);
}

/** A free dialer account's CRM: open only once it has bought something (a dialer subscription or leads). */
export const DIALER_CRM_PATHS = ["/leads", "/appointments"];

export const isDialerCrmPath = (pathname: string): boolean =>
  DIALER_CRM_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));

/** Pages LeadStoreSniper's free dialer account may open; anything else sends it to the console. */
export function dialerPathAllowed(pathname: string): boolean {
  return [DIALER_CONSOLE_PATH, ...DIALER_HOST_NAV, "/profile"].some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
